export default "__VITE_ASSET__cc0730d5__"